import React from 'react';

interface ReadStatusIconProps {
    isRead: boolean;
}

const ReadStatusIcon: React.FC<ReadStatusIconProps> = ({
                                                           isRead = false,
                                                       }) => {
    return (
        <span style={{position: 'relative', right:'7px', top: '-4px'}}>
        {isRead ? (<svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            width="12px"
            height="12px"
            color='white'
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m1 6l2.5 2.5l5-5m-2 5l5-5"
            ></path>
        </svg>) : (<svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
            width="12px"
            height="12px"
            color='white'
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m1 7l3 3l7-7"
            ></path>
        </svg>)}
</span>
    )
};

export default ReadStatusIcon;
